import { render } from "./contact.vue?vue&type=template&id=04d37cc7"
const script = {}

import "./contact.vue?vue&type=style&index=0&id=04d37cc7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__